import {
  PaginationResultsCostCenterUserAssignTableDataDto,
  PaginationResultsUserTableDto,
  AcceptConsentsRequest,
  InviteUserRequest,
  UserConsentsDto,
  SearchRequest,
  EditUserDto,
  MeUserDto,
  UserDto,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';

export async function currentUserDetails(): Promise<MeUserDto> {
  return httpClient.get('users/me').json();
}

export async function getUserConsents(): Promise<UserConsentsDto> {
  return httpClient.get('users/me/consents').json();
}

export async function acceptConsents(data: AcceptConsentsRequest): Promise<void> {
  return httpClient.post('users/me/consents', { json: data }).json();
}

export async function updateUser({
  id,
  data,
}: {
  data: EditUserDto;
  id: string;
}): Promise<UserDto> {
  return httpClient.put(`users/${id}`, { json: data }).json();
}

export async function getUsers(): Promise<UserDto[]> {
  return httpClient.get('users').json();
}

export async function getPaginatedUsers(
  request: SearchRequest,
): Promise<PaginationResultsUserTableDto> {
  return httpClient
    .get(`users/paged`, {
      searchParams: qs.stringify(request, { allowDots: true }),
    })
    .json();
}

export async function inviteUser(data: InviteUserRequest): Promise<UserDto> {
  return httpClient.post(`users/invite`, { json: data }).json();
}

export async function removeUser(userId: string): Promise<void> {
  return httpClient.delete(`users/${userId}`).json();
}

export async function transferAdminPlusRole(newAdminPlusId: string): Promise<MeUserDto> {
  return httpClient.post(`users/transfer-admin-plus-role/${newAdminPlusId}`).json();
}

export async function getUsersToAssign(
  request: SearchRequest,
): Promise<PaginationResultsCostCenterUserAssignTableDataDto> {
  const searchParams = qs.stringify(request, { allowDots: true });
  return httpClient.get('cost-centers/users/assign', { searchParams }).json();
}

export async function getAllAssignUsers(): Promise<UserDto[]> {
  return httpClient.get('cost-centers/users').json();
}

export async function getAssignedUsers(
  data: { ids: string[] } & SearchRequest,
): Promise<PaginationResultsCostCenterUserAssignTableDataDto> {
  return httpClient.post('cost-centers/users/assigned', { json: data }).json();
}
